import { Injectable, inject } from '@angular/core';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { EmploymentHistoryRecordDto } from '../models/dtos/employment-history-record-dto';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EmploymentHistoryRecordService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI + '/employmentHistoryRecord';

  constructor(){ }

  getEmploymentHistoryRecordById(employmenyHistoryRecordId: number): Observable<EmploymentHistoryRecordDto> {
    const url = `${this.API_URL}/${employmenyHistoryRecordId}`;
    return this.http.get<EmploymentHistoryRecordDto>(url);
  }

  setTemporaryWorkEmployer(employmentHistoryRecordId: number, temporaryWorkEmployerId: number) {
    const url = `${this.API_URL}/${employmentHistoryRecordId}/setTemporaryWorkEmployer`;
    return this.http.post(url, temporaryWorkEmployerId);
  }
}
